// extracted by mini-css-extract-plugin
export default {"container":"Gyroscope_container__OjsTb","content":"Gyroscope_content__Oc6TF"};